module.exports = window["SSCUI"]["locale"];